import { map_sector } from '@/app/utils/formatSearchData'
import { apiSlice } from '../apiSlice'
import { ProductWithIndustryResponse } from '@/app/types/constantDataType'

interface ProductFamily {
  id: number
  name: string
}

interface Product {
  id: number
  name: string
  product_family: ProductFamily
}

interface ResponseData {
  products: { id: number; name: string; product_family: ProductFamily }[]
}

export const companySearchSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyProducts: builder.query<Product[], string>({
      query: (industry_name) => ({
        url: `/products/find_by_industry?industry_name=${encodeURIComponent(map_sector[industry_name]) || 'AF Production'}`,
        method: 'GET',
      }),
      transformResponse: (responseData: ResponseData): Product[] => {
        const uniqueProducts = responseData.products.reduce<Product[]>(
          (acc, current) => {
            const existingProduct = acc.find(
              (item) => item.name === current.name
            )
            if (!existingProduct) {
              acc.push(current)
            }
            return acc
          },
          []
        )

        return uniqueProducts
      },
    }),

    getCompanyProductFamily: builder.query({
      query: (industry_name) => ({
        url: `/product_families/find_by_industry?industry_name=${encodeURIComponent(map_sector[industry_name]) || 'AF Production'}`,
        method: 'GET',
      }),
      transformResponse: async (responseData) => {
        return responseData
      },
    }),
    getProductsWithIndustry: builder.query({
      query: () => ({
        url: '/industries/products',
        method: 'GET',
      }),
      transformResponse: async (responseData: ProductWithIndustryResponse) => {
        return responseData.industries
      },
    }),
  }),
})

export const {
  useGetCompanyProductsQuery,
  useGetCompanyProductFamilyQuery,
  useGetProductsWithIndustryQuery,
} = companySearchSlice
